import { defaultAdapter } from 'react-datocms';
import { formatCurrency } from '@zopauk/libs-formats';
import { RepresentativeAprResponse } from '@/utils/queries/getRepresentativeApr';

export const representativeAprTextTransformer = ({
  monthlyPayment,
  totalInterest,
  interestRate,
  totalCredit,
  totalCost,
  years,
  loan,
  apr,
  fee,
}: RepresentativeAprResponse['repPrice']): typeof defaultAdapter.renderText => {
  const templates: { [key: string]: string } = {
    REP_MONTHLY_PAYMENT: formatCurrency(monthlyPayment),
    REP_TOTAL_INTEREST: formatCurrency(totalInterest),
    REP_TOTAL_CREDIT: formatCurrency(totalCredit),
    REP_TOTAL_COST: formatCurrency(totalCost),
    REP_INTEREST_RATE: `${interestRate}%`,
    REP_LOAN_AMOUNT: formatCurrency(loan),
    REP_FEE: formatCurrency(fee),
    REP_YEARS: years.toString(),
    REP_APR: `${apr}%`,
  };

  return (text) => {
    Object.keys(templates).forEach((name) => {
      text = text.replace(new RegExp(`\\{\\{${name}\\}\\}`, 'g'), templates[name]);
    });

    return text;
  };
};
